export default __webpack_public_path__ + "static/media/Warning.7feb8ce1.svg";